// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AVPo","index":"styles_index__2i8k9"};